import { useOnMount } from '@ardoq/hooks';
import { RefObject, createRef, useCallback, useMemo, useRef } from 'react';

export const useScrollLock = () => {
  const innerRef = useRef<RefObject<HTMLElement | null>>(createRef());
  const handlerOptions = useMemo(() => ({ capture: true, passive: false }), []);
  const wheelHandler = (event: Event) => {
    const externalRef = innerRef.current;
    if (!(event.target instanceof HTMLElement)) {
      return;
    }
    if (externalRef.current?.contains(event.target)) {
      event.preventDefault();
      return;
    }
  };
  const lockScrollingTo = useCallback(
    (ref: RefObject<HTMLElement | null>) => {
      innerRef.current = ref;
      document.addEventListener('wheel', wheelHandler, handlerOptions);
    },
    [handlerOptions]
  );
  const unlockScrolling = useCallback(() => {
    document.removeEventListener('wheel', wheelHandler, handlerOptions);
  }, [handlerOptions]);
  useOnMount(() => unlockScrolling);
  return [lockScrollingTo, unlockScrolling];
};
